import React from 'react'
import ReactDOM from 'react-dom'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'
import OfferSharing from '../../../site/layout/component/OfferSharing'

const debug = require('debug')('user banner')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-offer-sharing').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <OfferSharing {...props} hydrated />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
